import React from "react";
import PropTypes from "prop-types";
import CollectionLink from "../../utils/generate-collection-link";
import styles from "./styles.m.css";
import DigitalEbookStoryCard from "../../atoms/digital-ebook-story-card";
import CollectionTitleWithSeries from "../../atoms/CollectionTitleWithSeries";

const EightEbookCard = ({
  collection,
  numberOfCardsInViewDesktop = 2.9,
  numberOfCardsInViewTablet = 3,
  numberOfCardsInViewMobile = 1.3,
  accentColor
}) => {
  const slides = collection.items.map(({ story }) => (
    <DigitalEbookStoryCard key={story.id} story={story} className={styles.card} />
  ));

  return (
    <div className={styles.base}>
      <div className={`container ${styles["sec-wrapper"]}`}>
        {collection.name && (
          <CollectionLink collection={collection}>
            <CollectionTitleWithSeries title={collection.name} />
          </CollectionLink>
        )}
        <div className={styles["card-wrapper"]}>{slides}</div>
      </div>
    </div>
  );
};

EightEbookCard.propTypes = {
  accentColor: PropTypes.string,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default EightEbookCard;
